import React, { useState } from "react";
import PropTypes from "prop-types";
import Heading from "../../../elements/heading";
import BodyText from "../../../elements/body-text";
import InfoModal from "../../../components/InfoModal";
import { RichText } from "@sitecore-jss/sitecore-jss-react";
import Icon from "../../../elements/icon";
import ToolSectionType from "./ToolSectionType";
import { generateReactKey } from "../../../utils/reactKey";

const ToolSection = ({ match, lang, items = [], headingType, headingBody, body, serverResponseStatus, serverResponseErrorMsg, isLoading, isSpecialFormat }) => {
  const [showInfoModalIndex, setShowInfoModalIndex] = useState(-1);
  return (
    <div className="grid">
      <div className="page-description">
        <Heading
          {...{
            type: headingType,
            html: headingBody
          }}
          typographyClass="type-h2"
        />
        {body && <RichText tag="p" className="body" field={body} />}
      </div>
      <div className="tool-sections">
        {items.map(({ label, description, unit, infoIcon, infoModal, ...tools }, index) => (
          <div className="tool-section" key={generateReactKey()}>
            {label && (
              <div className="section-heading">
                <BodyText html={`<p>${label}</p>`} />
                {infoIcon && (
                  <>
                    <Icon
                      {...{
                        icon: {
                          alt:
                            '<svg xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 0 24 24" width="24"><path d="M0 0h24v24H0V0z" fill="none" /><path d="M11 7h2v2h-2zm0 4h2v6h-2zm1-9C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z" /></svg>'
                        },
                        onClick: () => {
                          setShowInfoModalIndex(index);
                        }
                      }}
                    />
                    {infoModal && (
                      <InfoModal
                        {...{
                          ...infoModal,
                          showModal: showInfoModalIndex === index,
                          setShowModal: () => {
                            setShowInfoModalIndex(null);
                          }
                        }}
                      />
                    )}
                  </>
                )}
              </div>
            )}
            <ToolSectionType
              {...{
                ...tools,
                match: match,
                unit: unit,
                serverResponseStatus: serverResponseStatus,
                serverResponseErrorMsg: serverResponseErrorMsg,
                isLoading: isLoading,
                lang: lang,
                isSpecialFormat
              }}
            />
            {description && <RichText tag="p" className="info" field={{ value: description }} />}
          </div>
        ))}
      </div>
    </div>
  );
};

ToolSection.propTypes = {
  items: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string,
      description: PropTypes.string,
      infoIcon: PropTypes.bool
    })
  ),
  heading: PropTypes.object,
  body: PropTypes.object
};

export default ToolSection;
